import React from 'react';
import { Hero } from '../components/hero/Hero';
import { ProofStrip } from '../components/sections/ProofStrip';
import { ManufacturerStrip } from '../components/sections/ManufacturerStrip';
import { WelcomeVideo } from '../components/sections/WelcomeVideo';
import { FeaturedModality } from '../components/sections/FeaturedModality';
import { Categories } from '../components/sections/Categories';
import { Process } from '../components/sections/Process';
import { UsedEquipment } from '../components/sections/UsedEquipment';
import { ProductDepth } from '../components/sections/ProductDepth';
import { ConciergeSuite } from '../components/sections/ConciergeSuite';
import { Testimonial } from '../components/sections/Testimonial';
import { FinalCTA } from '../components/sections/FinalCTA';
export function Home() {
  return <>
      <Hero data-id="element-339" data-mp="3kuijbji3ss8y" />
      <ManufacturerStrip data-id="element-340" data-mp="3kv0nd2b0carf" />
      <WelcomeVideo data-id="element-341" data-mp="3kxmx98ldf2ct" />
      <FeaturedModality data-id="element-342" data-mp="3owcg3gp6hc3u" />
      <Categories data-id="element-343" data-mp="3ovu85mt5l9g3" />
      <Process data-id="element-344" data-mp="3ovauwjeg798e" />
      <UsedEquipment data-id="element-345" data-mp="3oyym3bwf7jjy" />
      <ProductDepth data-id="element-346" data-mp="30wjcmpo0ou4v" />
      <ConciergeSuite data-id="element-347" data-mp="30x1j0f4e8oqi" />
      <Testimonial data-id="element-348" data-mp="30vgjsc74whmb" />
      <ProofStrip data-id="element-349" data-mp="30up1u46gmiei" />
      <FinalCTA data-id="element-350" data-mp="2vxouzr1sdbmc" />
    </>;
}